<template>
<div class="calendar-area">
    <div class="left-calendar-box">
      <div class="top-cal">
        <button class="btn-cal btn-prev" aria-label="이전 달" @click="prevMonth" title="이전 달">&lt;</button>
        <div class="calendar-date-box">
          <div class="month-picker-wrapper" :class="{ 'active visible':showMenu }">
            <div class="month-year-label picker" type="text" autocomplete="off" tabindex="0" >
              <div class="month-year-display" :disabled="disabled" :class="{'input': isDisplayInput}">
                <div class="txt-cal"> <span @click="openMenu">{{ displayYear }}. </span>
                  <strong @click="openMenu">{{ displayText }}</strong>
                  <span @click="openMenu">월</span>
                  <button class="btn-today" style="font-family: Spoqa Han sans-serif;" @click="goToday">오늘</button>
                </div>

              </div>
            </div>
            <div class="text"></div>
            <div class="date-popover" :class="menuClass" :style="menuStyle" tabindex="-1">
              <div class="picker" style="text-align: center">
                <div class="flexbox">
                  <span class="picker_prev" @click="prevYear"></span>
                  <div>{{year}}</div>
                  <span class="picker_next" @click="nextYear"></span>
                </div>
                <div class="flexbox monthItem">
                  <template v-for="(month, idx) in monthLabels">
                    <div class="item" @click="selectMonth(idx)" :key="idx">{{month}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn-cal btn-next" aria-label="다음 달" @click="nextMonth" title="다음 달">&gt;</button>
      </div>
        <!--</div> -->

      <div class="calendar-body">
        <table id="calendar-table" cellpadding="0" cellspacing="0" border="1" summary=""><caption>공간별 예약 현황 달력</caption>
          <colgroup>
            <col width="">
          </colgroup>
          <thead>
            <tr>
              <th style="font-family: Spoqa Han sans-serif;">일</th>
              <th style="font-family: Spoqa Han sans-serif;">월</th>
              <th style="font-family: Spoqa Han sans-serif;">화</th>
              <th style="font-family: Spoqa Han sans-serif;">수</th>
              <th style="font-family: Spoqa Han sans-serif;">목</th>
              <th style="font-family: Spoqa Han sans-serif;">금</th>
              <th style="font-family: Spoqa Han sans-serif;">토</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="week in calendarLayout">
              <td v-for="n in week.weekObj" @click="getBookingList(n.date)" :style="n.date.length > 0 ? 'cursor:pointer' : 'cursor:default'">
                <!-- style="cursor:pointer"> -->
                  <span class="box" :class="n.clickYn === 'Y' ? 'click' : (n.todayYn === 'Y' ? 'today' : '')"  :style="n.style">
                    <span class="num">{{n.dateDisp}}</span>
                    <span class="icon-box2">
                      <span v-for="k in n.icon" :class="k.class">
                        {{k.roomIcon}}
                      </span>
                    </span>
                  </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="info">
        <ul>
          <li v-for="(room, index) in roomList" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">
            <span :class="room.class"> {{room.roomIcon}} </span>
            <span v-b-tooltip.hover :title="room.name"> {{room.name}} </span>
          </li>
        </ul>
      </div>
    </div>
        
    <div class="right-calendar-box">
      <div class="top-info">
        <ul>
          <li style="padding-left: 5px;"><span class="box b1"></span> 대관완료</li>
          <li style="padding-left: 5px;"><span class="box b2"></span> 강좌</li>
          <li style="padding-left: 5px;"><span class="box b3"></span> 커뮤니티</li>
          <li style="padding-left: 5px;"><span class="box b4"></span> 대관신청</li>
          <li style="padding-left: 5px;"><span class="box b5"></span> 협상중</li>
          <li style="padding-left: 5px;"><span class="box b6"></span> 결제대기</li>
        </ul>
      </div>
      <div class="list-box">
        <div class="head-title" style="font-family: Spoqa Han sans-serif;">장소선택</div>
        <div class="list-info" style="overflow:auto">
          <ul id="list-info-ul">
            <li v-for="(booking, index) in bookingLayout">
              <strong style="font-family: Spoqa Han sans-serif;">{{booking.roomNm}}</strong>
                <a v-for="(time, index) in booking.timeList"  v-bind:href="time.url==='#'?'javascript:;':time.url" v-on:click="return onClick(this.event,time.status)" title="{{time.time}} {{time.info}}">
                  <span :class="time.classDisp" @mouseover="mouseoverTime(time.info)" @mouseleave="mouseleaveTime">
                    {{time.time}}
                    <span class="info-view" style="font-family: Spoqa Han sans-serif;"> {{time.info}} </span>
                  </span>
                </a>

            </li>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- END CONTENTS -->
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';

  export default {
    name: 'calendar-by-room',
    props: ['org', 'roomList'],
    components: {
      // Datepicker,
    },
    data() {
      return {
        progressing: false,
        url: '/api/bookings/date',
        date: '',
        baseTimes: ['0900', '0930', '1000', '1030', '1100', '1130', '1200',
          '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030'],
        timeIndex: ['0900', '0930', '1000', '1030', '1100', '1130', '1200',
          '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030', '2100'],
        durations: Array.from(Array(25).keys()).slice(1),
        format: 'MM/dd',
        calendarDate: '',
        booking: [],
        bookingByDate: [],
        inputClass: 'calendar-date-box__current-date display-inline',
        startTimeIndex: {},
        durationIndex: {},

        // 추가
        showMenu: false,
        year: moment().format('YYYY'),
        month: moment().format('MM'),
        value: {},
        disabled: false,
        placeHolder: '',
        monthLabels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        calendarLayout: [],
        bookingLayout: [],
        dateIndex: [],
      };
    },
    methods: {
      onClick(e, status) {
        if (status === 'READY') {
          const confirmResult = window.confirm('해당 시간대는 대관신청중 입니다.\n계속 진행하시겠습니까?');
          if (!confirmResult) {
            e.preventDefault();
          }
        }
        return true;
      },
      mouseoverTime(info) {
        if (info.length > 0) {
          $(event.target).children('.info-view').css('display', 'block');
        }
      },
      mouseleaveTime() {
        $(event.target).children('.info-view').css('display', 'none');
      },
      init() {
        document.addEventListener('click', (e) => {
          if (this.$el && !this.$el.contains(e.target)) {
            this.closeMenu();
          }
        }, false);
      },
      openMenu() {
        if (!this.disabled) {
          this.showMenu = true;
        }
      },
      closeMenu() {
        if (this.showMenu) {
          this.showMenu = false;
        }
      },
      prevYear() {
        const newYear = parseInt(this.year, 10) - 1;
        this.year = newYear.toString();
        const ymd = `${this.year}${(this.month.length < 2 ? `0${this.month}` : this.month)}01`;
        this.getBookingByMonth(ymd);
      },
      nextYear() {
        const newYear = parseInt(this.year, 10) + 1;
        this.year = newYear.toString();
        const ymd = `${this.year}${(this.month.length < 2 ? `0${this.month}` : this.month)}01`;
        this.getBookingByMonth(ymd);
      },
      prevMonth() {
        let newMonth = parseInt(this.month, 10) - 1;
        if (newMonth === 0) {
          newMonth = 12;
          this.year = parseInt(this.year, 10) - 1;
        }
        this.month = newMonth.toString();
        const ymd = `${this.year}${(this.month.length < 2 ? `0${this.month}` : this.month)}01`;
        this.getBookingByMonth(ymd);
      },
      nextMonth() {
        let newMonth = parseInt(this.month, 10) + 1;
        if (newMonth === 13) {
          newMonth = 1;
          this.year = parseInt(this.year, 10) + 1;
        }
        this.month = newMonth.toString();
        const ymd = `${this.year}${(this.month.length < 2 ? `0${this.month}` : this.month)}01`;
        this.getBookingByMonth(ymd);
      },
      selectMonth(idx) {
        this.month = (parseInt(idx, 10) + 1).toString();
        const ymd = `${this.year}${(this.month.length < 2 ? `0${this.month}` : this.month)}01`;
        this.getBookingByMonth(ymd);
        this.closeMenu();
      },
      getLastDate(date) {
        const year = parseInt(date.substring(0, 4), 10);
        const month = parseInt(date.substring(4, 6), 10);
        const lastDate = new Date(year, month, 0);
        // 월의 마지막 일자
        return lastDate.getDate();
      },
      getFirstDay(date) {
        const year = parseInt(date.substring(0, 4), 10);
        const month = parseInt(date.substring(4, 6), 10);
        const firstDay = new Date(year, month - 1, 1);
        // 월 1일의 요일
        return firstDay.getDay();
      },
      goToday() {
        this.year = parseInt(this.today.substring(0, 4), 10);
        this.month = parseInt(this.today.substring(4, 6), 10);
        this.getBookingByMonth(this.today);
      },
      drawCalendar(yyyyMMdd) {
        this.calendarLayout = [];
        this.dateIndex = [];
        const dateNum = this.getLastDate(yyyyMMdd.substring(0, 6));
        let dayChk = this.getFirstDay(yyyyMMdd.substring(0, 6));
        let weekObjTemp = [];

        let todayYn = '';
        let dateTemp = '';

        for (let i = 0; i < 7; i += 1) {
          weekObjTemp.push({
            date: '',
            dateDisp: '',
            todayYn: '',
            holiDayYn: '',
            clickYn: '',
            icon: [],
            style: { height: '105px' },
          });
        }

        for (let i = 0; i < dateNum; i += 1) {
          // 오늘 체크
          if (this.today === `${yyyyMMdd.substring(0, 6)}${((i + 1) < 10 ? `0${(i + 1)}` : (i + 1))}`) {
            todayYn = 'Y';
          } else {
            todayYn = 'N';
          }

          dateTemp = `${yyyyMMdd.substring(0, 6)}${((i + 1) < 10 ? `0${(i + 1)}` : (i + 1))}`;
          weekObjTemp[dayChk].date = dateTemp;
          weekObjTemp[dayChk].dateDisp = (i + 1);
          weekObjTemp[dayChk].todayYn = todayYn;
          weekObjTemp[dayChk].holiDayYn = 'N';
          this.dateIndex.push({
            dateObj: weekObjTemp[dayChk],
          });

          // 일요일 -> calendarLayout 데이터 추가 후 weekObj 초기화
          dayChk += 1;
          if (dayChk === 7 || (i + 1) === dateNum) {
            this.calendarLayout.push({
              weekObj: weekObjTemp,
            });

            weekObjTemp = [];
            for (let j = 0; j < 7; j += 1) {
              weekObjTemp.push({
                date: '',
                dateDisp: '',
                todayYn: '',
                holiDayYn: '',
                clickYn: '',
                icon: [],
                style: { height: '105px' },
              });
            }
            dayChk = 0;
          }
        }

        let idx = 0;
        for (let i = 0; i < this.booking.length; i += 1) {
          if (this.booking[i].status === 'DONE' || this.booking[i].status === 'LECTURE' || this.booking[i].status === 'PAYMENT_WAITING'
              || this.booking[i].status === 'NEGOTIATION' || this.booking[i].status === 'READY') {
            const room = this.roomList.filter(rm => rm.id === this.booking[i].roomId);

            // roomList -> 비공개 제외한 리스트 목록으로 값이 있는 경우만 달력에 icon표시
            if (room.length > 0) {
              idx = parseInt(this.booking[i].date.substring(4, 6), 10) - 1;
              const iconChk = this.dateIndex[idx].dateObj.icon.filter(
                icn => icn.roomId === room[0].id);

              if (iconChk.length === 0) {
                this.dateIndex[idx].dateObj.icon.push({
                  roomIcon: room[0].roomIcon,
                  class: room[0].class,
                  roomId: room[0].id,
                  roomName: room[0].name,
                });
              }

              // 공간 명 순으로 정렬
              this.dateIndex[idx].dateObj.icon.sort((a, b) => {
                if (a.roomName > b.roomName) {
                  return 1;
                } else if (a.roomName < b.roomName) {
                  return -1;
                }
                return 0;
              });
            }
          }
        }

        if (this.calendarLayout.length > 5) {
          $('#calendar-table').css('height', '660px');
          $('.list-box').css('height', '666px');
          $('.list-info').css('height', '630px');
          $('.info').css('padding-bottom', '20px');
        } else {
          $('#calendar-table').css('height', '560px');
          $('.list-box').css('height', '562px');
          $('.list-info').css('height', '520px');
          $('.info').css('padding-bottom', '20px');
        }
        this.getBookingList(yyyyMMdd);
      },
      initRoomList(yyyyMMdd) {
        // 현재 시간 이전, 이후 구분
        let classDispTemp;
        let classDispTempSub;
        let urlTemp = '#';
        const plusDay = String(moment(this.today).add(30, 'days').format('YYYYMMDD'));
        const applyDate = String(moment(this.today).add(2, 'days').format('YYYYMMDD'));
        if (parseInt(applyDate, 10) > parseInt(yyyyMMdd, 10)) {
          classDispTemp = 'time-box off';
        } else {
          classDispTemp = 'time-box on';
        }

        this.bookingLayout = [];
        let timeListTemp = [];
        for (let i = 0; i < this.roomList.length; i += 1) {
          this.roomList[i].class = `i-box e${(i + 1)}`;
          timeListTemp = [];
          for (let j = 0; j < this.baseTimes.length; j += 1) {
            const timeTemp = `${this.baseTimes[j].substring(0, 2)}${this.baseTimes[j].substring(2, 4)}`;
            if (classDispTemp === 'time-box on') {
              urlTemp = `/${this.org}/booking-apply.do?id=${this.roomList[i].id}&date=${yyyyMMdd}&time=${timeTemp}`;
            } else {
              urlTemp = '#';
            }
            classDispTempSub = classDispTemp;
            if (this.roomList[i].roomStat === 'NONE' && classDispTemp === 'time-box on') {
              classDispTempSub = 'time-box off';
              urlTemp = '#';
            } else if (this.roomList[i].roomStat === 'COMMUNITY' && classDispTemp === 'time-box on') {
              if (parseInt(plusDay, 10) < parseInt(yyyyMMdd, 10)) {
                classDispTempSub = 'time-box off';
                urlTemp = '#';
              }
            }
            timeListTemp.push({
              time: `${this.baseTimes[j].substring(0, 2)}:${this.baseTimes[j].substring(2, 4)}`,
              classDisp: classDispTempSub,
              info: '',
              url: urlTemp,
            });
          }

          // room length
          this.bookingLayout.push({
            timeList: timeListTemp,
            roomId: this.roomList[i].id,
            roomNm: this.roomList[i].name,
            stat: this.roomList[i].roomStat,
          });
        }
      },
      clickCalendar(date) {
        $('.list-info').scrollTop(0);
        for (let i = 0; i < this.dateIndex.length; i += 1) {
          this.dateIndex[i].dateObj.clickYn = '';
        }
        const idx = parseInt(date.substring(4, 6), 10) - 1;
        this.dateIndex[idx].dateObj.clickYn = 'Y';
      },
      drawBookingGrid(yyyyMMdd) {
        this.initRoomList(yyyyMMdd);
        this.clickCalendar(yyyyMMdd.substring(2, 8));

        for (let i = 0; i < this.roomList.length; i += 1) {
          // room length
          if (this.bookingByDate.length > 0) {
            const bookingList = this.bookingByDate.filter(
              booking => booking.roomId === this.roomList[i].id);

            for (let j = 0; j < bookingList.length; j += 1) {
              const strtTimeIdx = this.timeIndex.indexOf(bookingList[j].startTime);
              const endTimeIdx = this.timeIndex.indexOf(bookingList[j].endTime);

              if (bookingList[j].communityId !== null && bookingList[j].status === 'DONE') {
                bookingList[j].status = 'COMMUNITY';
              }

              for (let k = strtTimeIdx; k < endTimeIdx; k += 1) {
                this.bookingLayout[i].timeList[k].status = bookingList[j].status;
                if (bookingList[j].status === 'DONE') {
                  this.bookingLayout[i].timeList[k].classDisp = 'time-box on b1';
                  this.bookingLayout[i].timeList[k].info = bookingList[j].grpNm;
                  this.bookingLayout[i].timeList[k].url = '#';
                } else if (bookingList[j].status === 'LECTURE') {
                  this.bookingLayout[i].timeList[k].classDisp = 'time-box on b2';
                  this.bookingLayout[i].timeList[k].info = bookingList[j].purpose;
                  this.bookingLayout[i].timeList[k].url = '#';
                } else if (bookingList[j].status === 'COMMUNITY') {
                  this.bookingLayout[i].timeList[k].classDisp = 'time-box on b3';
                  this.bookingLayout[i].timeList[k].info = bookingList[j].grpNm;
                } else if (bookingList[j].status === 'NEGOTIATION') {
                  this.bookingLayout[i].timeList[k].classDisp = 'time-box on b5';
                  this.bookingLayout[i].timeList[k].info = bookingList[j].grpNm;
                } else if (bookingList[j].status === 'PAYMENT_WAITING') {
                  this.bookingLayout[i].timeList[k].classDisp = 'time-box on b6';
                  this.bookingLayout[i].timeList[k].info = bookingList[j].grpNm;
                  this.bookingLayout[i].timeList[k].url = '#';
                } else if (bookingList[j].status === 'READY') {
                  // 대관신청은 여러건 신청 가능하기 때문에 대관 되어 있는 경우 css 적용하지 않음
                  if (this.bookingLayout[i].timeList[k].info !== null
                      && this.bookingLayout[i].timeList[k].info.length === 0) {
                    this.bookingLayout[i].timeList[k].classDisp = 'time-box on b4';
                    this.bookingLayout[i].timeList[k].info = bookingList[j].grpNm;
                  }
                }
              }
            }
          }
        }
      },
      getBookingByMonth(yyyyMMdd) {
        const inputMonth = yyyyMMdd.substring(2, 6);
        axios.get('/api/bookings/month', { params: { org: this.org, month: inputMonth } }).then((res) => {
          this.booking = res.data || [];
          this.drawCalendar(yyyyMMdd);
        }).catch(e => console.log(e));
      },
      getBookingList(yyyyMMdd) {
        if (yyyyMMdd === '') {
          return;
        }
        const inputDate = yyyyMMdd.substring(2, 8);
        axios.get(this.url, { params: { org: this.org, date: inputDate } }).then((res) => {
          this.bookingByDate = res.data || [];
          this.drawBookingGrid(yyyyMMdd);
        }).catch(e => console.log(e));
      },
      /*
      getPrevDate() {
        const curruntDate = moment(`20${this.date.slice(0, 2)}
        -${this.date.slice(2, 4)}-${this.date.slice(4)}`);
        $('input[name=calendarDate]').val(moment(curruntDate).add(-1, 'days').format('MM/DD'));
        const getVal = String(moment(curruntDate).add(-1, 'days'));
        const year = getVal.slice(13, 15);
        const mon = getVal.slice(4, 7);
        const day = getVal.slice(8, 10);
        this.date = `${year}${MonChange[mon]}${day}`;
        this.getBookingList();
      },
      getNextDate() {
        const curruntDate = moment(`20${this.date.slice(0, 2)}
        -${this.date.slice(2, 4)}-${this.date.slice(4)}`);
        $('input[name=calendarDate]').val(moment(curruntDate).add(1, 'days').format('MM/DD'));
        const getVal = String(moment(curruntDate).add(1, 'days'));
        const year = getVal.slice(13, 15);
        const mon = getVal.slice(4, 7);
        const day = getVal.slice(8, 10);
        this.date = `${year}${MonChange[mon]}${day}`;
        this.getBookingList();
      },
      getBookingList() {
        axios.get(this.url, { params: { org: this.org, date: this.date } }).then((res) => {
          this.booking = res.data || [];
        }).catch(e => console.log(e));
      },
      changeChalendar(val) {
        const getVal = String(val);
        const year = getVal.slice(13, 15);
        const mon = getVal.slice(4, 7);
        const day = getVal.slice(8, 10);
        this.date = `${year}${MonChange[mon]}${day}`;
        this.getBookingList();
      },
      getStatusBookingListByRoom(roomId) {
        const bookings = [];
        const bookingList = this.booking;
        for (let i = 0; i < bookingList.length; i += 1) {
          if (bookingList[i].roomId === roomId) {
            bookings.push(bookingList[i]);
          }
        }
        bookings.sort((a, b) => {
          if (a.status > b.status) {
            return -1;
          } else if (a.status < b.status) {
            return 1;
          }
          return 0;
        });
        return bookings;
      },
      times(bookingList) {
        const trTime = [];
        const baseTimes = this.baseTimes;
        for (let i = 0; i < baseTimes.length; i += 1) {
          const visibleValue = true;
          let statusValue = 'EMPTY';
          let selectedBooking = {};

          for (let j = 0; j < bookingList.length; j += 1) {
            const startTime = parseInt(bookingList[j].startTime, 10);
            const endTime = parseInt(bookingList[j].endTime, 10);
            if (parseInt(baseTimes[i], 10) >= startTime && parseInt(baseTimes[i], 10) < endTime) {
              statusValue = bookingList[j].status;
              if (bookingList[j].status === 'DONE' || bookingList[j].status === 'LECTURE') {
                statusValue = 'td-booking';
              } else if (bookingList[j].status === 'NEGOTIATION') {
                statusValue = 'td-negotiation';
              }
              selectedBooking = bookingList[j];
            }
          }
          trTime.push({ status: statusValue,
            visible: visibleValue,
            booking: selectedBooking,
          });
        }
        return trTime;
      },
      trByBookingList() {
        const trList = [];
        const roomList = this.roomList;
        for (let i = 0; i < roomList.length; i += 1) {
          const rowCount = 1;
          const tdVisibleValue = true;
          const doneBookingList = this.getStatusBookingListByRoom(roomList[i].id);
          trList.push({ rowSpan: rowCount,
            roomId: roomList[i].id,
            roomName: roomList[i].name,
            tdVisible: tdVisibleValue,
            minPersonnel: roomList[i].minPersonnel,
            maxPersonnel: roomList[i].maxPersonnel,
            bookingList: doneBookingList,
          });
        }
        return trList;
      },
      */
    },
    mounted() {
      const getMoment = moment().locale('ko');
      const today = getMoment.format('YYYYMMDD');
      this.today = today;
      this.init();
      this.initRoomList(today);
      this.getBookingByMonth(today);

      // this.date = getMoment.format('YYMMDD');
      // $('input[name=calendarDate]').val(today);
      // this.startTimes.forEach((value, index) => (this.startTimeIndex[value] = index));
      // this.durations.forEach((value, index) => (this.durationIndex[value] = index));
      // this.getBookingList();
    },
    computed: {
      menuClass() {
        return {
          visible: this.showMenu,
          hidden: !this.showMenu,
        };
      },
      menuStyle() {
        return {
          display: this.showMenu ? 'block' : 'none',
        };
      },
      displayYear() {
        if (this.value) {
          return this.year;
        }
        return this.placeHolder;
      },
      displayText() {
        if (this.value) {
          return this.month;
        }
        return this.placeHolder;
      },
    },
  };
</script>
<style lang="scss">
  .calendar-date-box__current-date {
    display: inline;
    width: 65%;
    float: left;
    height: 42px;
    border: none;
    text-align: center;
  }

  $lightgray: #d4d4d4;
  .picker {
    .picker_next,
    .picker_prev { &:hover {cursor: pointer;} }
    .monthItem {
      .item {
        border-top: 1px solid $lightgray;
        &:hover {
          cursor: pointer;
          background-color: $lightgray;
        }
      }
    }
    .flexbox {
      padding: 0px;
      display: flex;
      flex-wrap: wrap;
      div {
        flex-grow: 1;
        padding: 15px 0;
      }
      .item {
        flex: 1;
        flex-basis: 25%;
      }
    }
  }

  .placeholder {
    color: #8b8b8b;
  }

  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    margin: 0 -1px;
    min-width: 100%;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #fff;
    transition: opacity .1s ease;
    position: relative;
    left: 0;
    top: 0;
    z-index: 10;
    border: 1px solid $lightgray;
    font-size: 1rem;
    font-weight: 200;
  }

  .month-picker-wrapper {
    position: relative;
    display: block;
    min-width: 200px;
  }

  .month-year-label {
    outline: none;
  }
  .text {
    position: relative;
    z-index: 2;
  }
  .month-year-display {
    &:hover {
      cursor: pointer;
    }
  }

  .picker_next,
  .picker_prev {
    width: 16%;
    float: left;
    text-indent: -10000px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      border: 6px solid transparent;
    }
  }

  .picker_next {
    &:after {
      border-left: 10px solid #000;
      margin-left: 5px;
    }
  }

  .picker_prev {
    &:after {
      border-right: 10px solid #000;
      margin-left: -5px;
    }
  }

  .calendar-date-box {
    height: 31px;
  }

  .calendar-area .left-calendar-box .i-box.e1 { background-color:#595cda; }
  .calendar-area .left-calendar-box .i-box.e2 { background-color:#da59bd; }
  .calendar-area .left-calendar-box .i-box.e3 { background-color:#40bed5; }
  .calendar-area .left-calendar-box .i-box.e4 { background-color:#21ce8a; }
  .calendar-area .left-calendar-box .i-box.e5 { background-color:#da8f59; }
  .calendar-area .left-calendar-box .i-box.e6 { background-color:#afb425; }
  .calendar-area .left-calendar-box .i-box.e7 { background-color:#fb7c33; }
  .calendar-area .left-calendar-box .i-box.e8 { background-color:#da595f; }
  .calendar-area .left-calendar-box .i-box.e9 { background-color:#59a2da; }
  .calendar-area .left-calendar-box .i-box.e10 { background-color:#9059da; }
  .calendar-area .left-calendar-box .i-box.e11 { background-color:#d0001b; }
  .calendar-area .left-calendar-box .i-box.e12 { background-color:#0030d0; }
  .calendar-area .left-calendar-box .i-box.e13 { background-color:#3d9aa9; }
  .calendar-area .left-calendar-box .i-box.e14 { background-color:#5baf4c; }
  .calendar-area .left-calendar-box .i-box.e15 { background-color:#adb535; }
  .calendar-area .left-calendar-box .i-box.e16 { background-color:#3b145f; }
  .calendar-area .left-calendar-box .i-box.e17 { background-color:#d6abc9; }
  .calendar-area .left-calendar-box .i-box.e18 { background-color:#da595f; }
  .calendar-area .left-calendar-box .i-box.e19 { background-color:#986417; }
  .calendar-area .left-calendar-box .i-box.e20 { background-color:#224833; }
  .calendar-area .left-calendar-box .calendar-body tbody td .box.click { background-color:#dee1f3; }

  .calendar-area .right-calendar-box .top-info li .box.b1 { border:2px solid #8dd69e !important; }
  .calendar-area .right-calendar-box .top-info li .box.b2 { border:2px solid #F1C40F !important; }
  .calendar-area .right-calendar-box .top-info li .box.b3 { border:2px solid #c66bec !important; }
  .calendar-area .right-calendar-box .top-info li .box.b4 { border:2px solid #659be0 !important; }
  .calendar-area .right-calendar-box .top-info li .box.b5 { border:2px solid #ed6b75 !important; }
  .calendar-area .right-calendar-box .top-info li .box.b6 { border:2px solid #e19669 !important; }

  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b1 { border:1px solid #8dd69e !important; color:#8dd69e !important; }
  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b2 { border:1px solid #F1C40F !important; color:#F1C40F !important; }
  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b3 { border:1px solid #c66bec !important; color:#c66bec !important; }
  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b4 { border:1px solid #659be0 !important; color:#659be0 !important; }
  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b5 { border:1px solid #ed6b75 !important; color:#ed6b75 !important; }
  .calendar-area .right-calendar-box .list-box .list-info li .time-box.b6 { border:1px solid #e19669 !important; color:#e19669 !important; }
</style>



// WEBPACK FOOTER //
// CalendarByRoom.vue?6a52d85e